/**
 * File: fr-FR.js
 * Project: Aitea-Building
 * File Created: Friday, 25th October 2024 11:18:09 am
 * Author: Daniel Rodríguez Cabrera (daniel.rodriguez@aerin.es)
 * Version: 2.0.0
 * -----
 * Last Modified: Friday, 25th October 2024 11:41:54 am
 * Modified By: Daniel Rodríguez Cabrera
 * -----
 * Copyright (c) 2023 - 2024 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

import enMessages from '../locales/it_IT';

const ItLang = {
  messages: {
    ...enMessages,
  },
  locale: 'it-IT',
};

export default ItLang;
